import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {EntityType} from "../../gd/const/item";
import {FieldType} from "../../fields3/field-type";
import FieldText from "../../fields3/generic/text/text";
import FieldTimeOfDay from "../../fields3/generic/datetime/time-of-day/time-of-day";
import FieldOffice from "../../fields3/system/company/office/office";
import FieldDate from "../../fields3/generic/datetime/date/date";
import FieldUser from "../../fields3/generic/user/user";

const baseConfig = [
    {
        fieldId         : 'date',
        type            : FieldType.DATE,
        label           : 'Date',
    },
    {
        fieldId         : 'createdByUserId',
        type            : FieldType.USER,
        label           : 'User',
    },
    {
        fieldId         : 'comment',
        type            : FieldType.TEXT,
        label           : 'Comments',
    },
    {
        fieldId         : 'timestamp',
        type            : FieldType.TIME_OF_DAY,
        label           : 'Time',
    },

    {
        fieldId         : 'officeId',
        type            : FieldType.COMPANY_OFFICE,
        label           : 'Location'
    }

]

export default class AttendanceFields extends FieldsCollection {

    get date()           { return this.get('date') as FieldDate }
    get createdByUserId(){ return this.get('createdByUserId') as FieldUser }
    get comment()        { return this.get('comment') as FieldText }
    get timestamp()      { return this.get('timestamp') as FieldTimeOfDay }
    get officeId()       { return this.get('officeId') as FieldOffice }

    constructor() {
        super(baseConfig, EntityType.ATTENDANCE_EVENT)
    }
}
